export const lenaBunnyHeightSliderTest = ({
	buildsignature,
	categoryid,
	createtime,
	desyncdata,
	desyncid,
	screenshot,
	sessionid,
	sku,
	systemconfig,
	type,
	version,
}) => {
	if (desyncdata !== undefined) {
		if (desyncdata.indexOf('cannot import name SimInfoBaseWrapper') !== -1 && desyncdata.indexOf('AddSimSlider') !== -1) {
			return {
				type: 'lenaBunnyHeightSliderTest',
				color: 'IndianRed',
				title: 'Outdated Height Slider mod by LenaBunny',
				text: 'You\'re using an outdated version of Height Slider by LenaBunny.',
				description: 'Remove all files related to the <strong>Height Slider</strong> mod and check if there is a recent update available.'
			}
		}
	}
}

// EXAMPLE
/*
<root>
  <report>
    <version>2</version>
    <sessionid>a2b525b14c5f07c45b665963</sessionid>
    <type>desync</type>
    <sku>ea.maxis.sims4_64.15.pc</sku>
    <createtime>2018-08-04 21:57:18</createtime>
    <buildsignature>Local.Unknown.Unknown.1.45.62.1020-1.200.000.360.Release</buildsignature>
    <categoryid>AddSimSlider.py:15</categoryid>
    <desyncid>a2b525b14c5f07c45b665963</desyncid>
    <systemconfig/>
    <screenshot/>
    <desyncdata>Failure: 'AddSimSlider' (AddSimSlider) (ImportError: cannot import name SimInfoBaseWrapper)
Traceback (most recent call last):
  File &quot;T:\InGame\Gameplay\Scripts\Core\sims4\importer\utils.py&quot;, line 119, in import_modules_by_path
  File &quot;T:\InGame\Gameplay\Scripts\Core\sims4\importer\utils.py&quot;, line 116, in import_modules_by_path
  File &quot;T:\InGame\Gameplay\Scripts\Core\sims4\importer\custom_import.py&quot;, line 72, in load_module
  File &quot;C:\Users\LenaBunny\Documents\Electronic Arts\The Sims 4\Mods\Height Slider\AddSimSlider.ts4script\AddSimSlider.py&quot;, line 15, in &lt;module&gt;
ImportError: cannot import name SimInfoBaseWrapper
</desyncdata>
  </report>
</root>
*/



// WEBPACK FOOTER //
// ./src/tests/mods/authors/lenaBunnyModsTest.js